import type { DriveStep } from 'driver.js';
import type { NavigateFunction } from 'react-router-dom';
import type { TFunction } from 'i18next';

export const createHomeTourSteps = (
  t: TFunction,
  navigate: NavigateFunction,
  onFinish: () => void,
): DriveStep[] => [
  {
    element: document.body,
    popover: {
      title: t('onboarding.home.welcome_title', 'Добро пожаловать в SpeechAI!'),
      description: t(
        'onboarding.home.welcome_desc',
        'Мы поможем вам подготовиться к публичному выступлению шаг за шагом. Давайте познакомимся с приложением.',
      ),
    },
  },
  {
    element: '[data-tour="home-card-preparation"]',
    popover: {
      title: t('onboarding.home.card_preparation_title', 'Подготовка с анализом'),
      description: t(
        'onboarding.home.card_preparation_desc',
        'Загрузите вашу презентацию (PDF), задайте цель и аудиторию — ИИ проанализирует её и создаст текст выступления.',
      ),
    },
  },
  {
    element: '[data-tour="home-card-ideas"]',
    popover: {
      title: t('onboarding.home.card_ideas_title', 'Генерация идей'),
      description: t(
        'onboarding.home.card_ideas_desc',
        'Нет готовой презентации? Опишите тему и аудиторию — мы сгенерируем идеи и концепцию выступления.',
      ),
    },
  },
  {
    element: '[data-tour="home-btn-preparation"]',
    popover: {
      title: t('onboarding.home.btn_title', 'Начнём!'),
      description: t(
        'onboarding.home.btn_desc',
        'Нажмите «Начать подготовку», чтобы перейти к загрузке материалов.',
      ),
      onNextClick: () => {
        navigate('/preparation');
        onFinish();
      },
    },
  },
];
